// Customizable Area Start
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import MessageEnum, {
  getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

interface Props {
  navigation: any;
}

interface S {
  currentTab: number | null;
  showSignupModal: boolean;
  pendingRoute: string | null;
}

interface SS { }

export default class MobileNavEndUserController extends BlockComponent<
  Props,
  S,
  SS
> {
  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      currentTab: 0,
      showSignupModal: false,
      pendingRoute: null
    };

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    this.updateActiveTab(window.location.pathname);
  }

  updateActiveTab(path: string) {
    let activeTab = null;
    if (path.includes("/EuDashboard")) {
      activeTab = 0;
    } else if (path.includes("/EuTredning")) {
      activeTab = 1;
    } else if (path.includes("/EuCreatepost")) {
      activeTab = 2;
    } else if (path.includes("/EuNotification")) {
      activeTab = 3;
    } else if (path.includes("/EuProfile")) {
      activeTab = 4;
    }
    this.setState({ currentTab: activeTab });
  }

  handleChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    this.setState({ currentTab: newValue });
    const authToken = localStorage.getItem('authToken');
    const EUAuthToken = localStorage.getItem('EUAuthToken');
    switch (newValue) {
      case 0:
        if (window.location.pathname.toLowerCase().includes("eudashboard")) {
          // Already on EU Home: scroll to top instead of navigating
          const w: any = window as any;
          if (w && typeof w.handleHomeFromReels === "function") {
            w.handleHomeFromReels();
          } else {
            if (w && typeof w.forceScrollToTop === "function") {
              w.forceScrollToTop();
            }
            if (w && typeof w.resetToHomeView === "function") {
              w.resetToHomeView();
            }
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }
        } else {
          this.handleRedirect("EuDashboard");
        }
        break;
      case 1:
        this.handleRedirect("EuTredning");
        break;
      case 2:
        if (!authToken && !EUAuthToken) {
          // Show signup modal for unauthenticated users
          this.setState({ showSignupModal: true, pendingRoute: "EuCreatepost" });
        } else {
          this.handleRedirect("EuCreatepost");
        }
        break;
      case 3:
        if (!authToken && !EUAuthToken) {
          this.handleRedirect("EndUserSignIn");
        } else {
          this.handleRedirect("EuNotification");
        }
        break;
      case 4:
        if (!authToken && !EUAuthToken) {
          this.handleRedirect("EndUserSignIn");
        } else {
          this.handleRedirect("EuProfile");
        }
        break;
      default:
        break;
    }
  };

  handleRedirect = (path: string) => {
    const currentSearch = window.location.search;
    let newPath = path;

    const hasExistingQuery = path.includes("?");

    if (currentSearch) {
      const separator = hasExistingQuery ? "&" : "?";
      const searchParams = currentSearch.startsWith("?")
        ? currentSearch.substring(1)
        : currentSearch;
      newPath = `${path}${separator}${searchParams}`;
    }
    this.props.navigation?.history?.push(newPath);
    // const msg = new Message(getName(MessageEnum.NavigationMessage));
    // msg.addData(getName(MessageEnum.NavigationTargetMessage), newPath);
    // msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    // this.send(msg);
  };

  handleSignupSuccess = () => {
    // Close modal and navigate to pending route after successful signup
    this.setState({ showSignupModal: false });
    if (this.state.pendingRoute) {
      this.handleRedirect(this.state.pendingRoute);
      this.setState({ pendingRoute: null });
    }
  };

  handleSignupClose = () => {
    // Close modal without navigation
    this.setState({ showSignupModal: false, pendingRoute: null });
  };
}
// Customizable Area End
